import { AGGREGATION_RULES } from './static_data';
// @ts-ignore
import { intelligenceMetricsData } from '@/pages/intelligence/pages/SourcesMetrics/components/DataMap/DetailInfo/FixData';

/**
 * 获取聚合的提示文本
 * @param type 游戏类型
 * @param market 指标名
 * @param platform 平台
 * @returns 提示内容
 */
export const getAggregationTipContent = (type: string, market: string, platform: string) => {
  // 把类型，指标，平台拼接成对应的key
  let key = `${type.trim().replace(/\s+/g, '-')}_${market.trim().replace(/\s+/g, '-')}_${platform.trim().replace(/\s+/g, '-')}`;
  if (!AGGREGATION_RULES[key]) return '';

  switch (key) {
    case 'Mobile_RPD_Appannie':
      return 'Take the cumulative revenue divided by cumulative downloads in selected time interval.';

    case 'PC_Digital-AST_MScience':
      return 'AST is Average Spending per Transaction. Take the WEIGHTED AVG value in selected time interval.';

    case 'PC_ACU_Steam':
      return 'ACU is the AVG Concurrent User. Take the AVG value in selected time interval.';

    case 'PC_Acquisitions%_Newzoo':
      return 'Acquisitions% is the percentage of players acquired by the game among all players of the genre. Take the WEIGHTED AVG value in selected time interval.';

    case 'Console_Digital-AST_MScience':
      return 'AST is Average Spending per Transaction. Take the WEIGHTED AVG value in selected time interval.';

    case 'Console_Acquisitions%_Newzoo':
      return 'Acquisitions% is the percentage of players acquired by the game among all players of the genre. Take the WEIGHTED AVG value in selected time interval.';

    case 'Streaming_Peak-CCV_Stream-Hatchet':
    case 'Mobile_Peak-CCV_Stream-Hatchet':
    case 'PC_Peak-CCV_Stream-Hatchet':
    case 'Console_Peak-CCV_Stream-Hatchet':
      return 'Here shows the peak number of concurrent viewership. Take the MAX value of selected time interval.';

    case 'Mobile_Retention-D2_':
    case 'Mobile_Retention-D2_Appannie':
      return 'Take the AVG Retention-D2 in selected time interval and valid country range.';
    //   revenue特殊说明
    case 'Mobile_Revenue_Appannie':
    case 'Mobile_Revenue_SensorTower':
    case 'Mobile_Revenue_DataBrain':
      return (
        `<p>Take the ${AGGREGATION_RULES[key]} value in selected time interval.</p>
            <p> Revenue has removed 30% commission from in-app purchases, subscriptions and paid app downloads.</p>`
      )
    case 'Mobile_D2_Appannie':
      return `Percentage of users who opened the app again on the 2nd day after first time the app was launched by users. `
    case 'Mobile_D3_Appannie':
      return `Percentage of users who opened the app again on the 3rd day after first time the app was launched by users.`
    case 'Mobile_D7_Appannie':
      return `Percentage of users who opened the app again on the 7th day after first time the app was launched by users.`
    case 'Mobile_D15_Appannie':
      return `
        <p>Percentage of users who opened the app again on the 15th day after first time the app was launched by users.</p>
        <p>data.ai can only provide the retention data on the 15th day, so there is no Annie D14 (双周留存) .</P>
        `
    case 'Mobile_D31_Appannie':
      return `
        <p>Percentage of users who opened the app again on the 31st day after first time the app was launched by users.</p>
        <P>data.ai can only provide the retention data on the 31st day, so there is no Annie D30 (月留存) .</P>
        `
    case 'PC_Digital-Units_MScience':
    case 'Console_Digital-Units_MScience':
      return `"Units" indicates the number of orders, units of segment "All" is reasonably smaller than the sum units of other segments. Since one single order might include base game and DLC, etc. Take the SUM value with selected countries.`

    default:
      return `Take the ${AGGREGATION_RULES[key]} value in selected time interval.`
  }
}

/**
 * Ranking数据源，获取数据地图对应指标的英文解释
 * @param gameType 游戏类型
 * @param metricName 指标名称
 * @param dataSource 数据源
 * return 英文注解
 */
export const getDataMapMetricsEnInfo = (gameType: string, metricName: string, dataSource: string) => {
  // const resultItem = intelligenceMetricsData?.filter((t: any) => (
  //   (t?.sourceType === (gameType + ' Game')) &&
  //   (t?.metriceName === metricName) &&
  //   (t?.dataSource === dataSource))
  // );

  // return resultItem?.[0]?.remarks?.split('\n')?.[0] || resultItem?.[0]?.remarks || '';
}
